import PropTypes from 'prop-types';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import RichText, { fragment } from '../../Core/RichText';
import Link from '../../Core/Link';
import ProTip from '../ProTip';
import IndividualBlade from '../IndividualBlades';
import AppStores from '../AppStores';
import InterestsTableComponent from '../../Providers/Core/Services/InterestsTable';

import {
  StyledContainer,
  Block,
  Heading,
  Body,
  Statement,
  CTAWrapper,
  Subtitle,
} from './styles';

const MissionStatement = ({ data = null, className = '' }) => {
  if (!data) return null;
  const {
    component,
    layoutType,
    textAlignment,
    backgroundColor,
    headingStyle,
    heading,
    bodyCopy,
    badges,
    ctas,
    tipSection,
  } = data;

  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Statement>{children}</Statement>,
      [BLOCKS.HEADING_1]: (_, children) => (
        <h1 className={headingStyle}>{children}</h1>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <h2 className={headingStyle}>{children}</h2>
      ),
      [BLOCKS.HEADING_3]: (_, children) => (
        <h3 className={headingStyle}>{children}</h3>
      ),
      [BLOCKS.HEADING_6]: (_, children) => <Subtitle>{children}</Subtitle>,
      [INLINES.HYPERLINK]: (node, children) => {
        const { data: nodeData } = node;
        return (
          <Link className="rich-text-link" to={nodeData.uri} fontSize="inherit">
            {children}
          </Link>
        );
      },
      [BLOCKS.EMBEDDED_ENTRY]: node => {
        const { data: nodeData } = node;
        if (
          nodeData.target.__typename === 'ContentfulCoreApi' &&
          nodeData.target.apiCall === 'interests'
        ) {
          return <InterestsTableComponent />;
        }
        return null;
      },
    },
  };

  return (
    <StyledContainer
      backgroundColor={backgroundColor}
      className={className || component}
    >
      <Block className={`${layoutType} ${component}`}>
        {heading && (
          <Heading className={`${textAlignment} ${layoutType}`}>
            <RichText document={heading} options={options} />
          </Heading>
        )}
        {(bodyCopy || badges || ctas || tipSection) && (
          <Body className={`${textAlignment} ${layoutType}`}>
            {bodyCopy && <RichText document={bodyCopy} options={options} />}
            {badges && <AppStores badges={badges} />}
            {ctas && (
              <CTAWrapper className={`${textAlignment} ${layoutType}`}>
                {ctas.map(cta => {
                  if (cta.hideFrench === true) return null;
                  return cta.internal.type === 'ContentfulBlade' ? (
                    <IndividualBlade key={cta.id} data={cta} />
                  ) : (
                    <Link key={cta.id} data={cta}>
                      <RichText document={cta.label} options={fragment} />
                    </Link>
                  );
                })}
              </CTAWrapper>
            )}
            {tipSection &&
              tipSection.map(tip => <ProTip key={tip.id} data={tip} />)}
          </Body>
        )}
      </Block>
    </StyledContainer>
  );
};

MissionStatement.propTypes = {
  data: PropTypes.oneOfType([PropTypes.shape(), PropTypes.bool]),
  className: PropTypes.string,
};

export default MissionStatement;
